package one.devsbox.www.ui.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.LocalPreferencesProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.provider.PreferencesProvider
import one.devsbox.www.ui.campaigns.ListingCampaignsUI
import one.devsbox.www.ui.devices.ListingDevicesUI
import one.devsbox.www.ui.locations.ListingLocationUI
import one.devsbox.www.ui.resources.ListingResourcesUI
import one.devsbox.www.ui.users.ListingUsersUI
import one.devsbox.www.ui.widgets.EmptyUI
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.viewModel

class HomeCtx private constructor(
    val vm: HomeVM,
    val nav: Navigation,
    val me: MeProvider,
    val prefs: PreferencesProvider
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): HomeCtx {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(HomeVM::class)
            val me = LocalMeProvider.current
            val prefs = LocalPreferencesProvider.current
            return remember {
                HomeCtx(vm, nav, me, prefs).apply {
                    vm.setup(this)
                }
            }
        }
    }

    @Composable
    fun TargetUI() {
        val active = vm.active
        if (active == Node.ListingCampaignsUI) ListingCampaignsUI()
        else if (active == Node.ListingDevicesUI) ListingDevicesUI()
        else if (active == Node.ListingLocationUI) ListingLocationUI()
        else if (active == Node.ListingResourcesUI) ListingResourcesUI()
        else if (active == Node.ListingUsersUI) ListingUsersUI()
        else EmptyUI()
    }
}
